import React, { useRef, useState } from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { useClickOutside } from '@utils/hooks/useClickOutside';
import Checkbox from '@components/_shared/checkbox';

import styles from './styles.module.scss';

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
} & BaseComponentProps;

PetCheckbox.defaultProps = {
  value: false,
};

export function PetCheckbox(props: Props) {
  const { containerStyle, value, onChange } = props;
  const [showContainer, setShowContainer] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const toggleContainer = () => setShowContainer((value) => !value);

  const closeContainer = () => setShowContainer(false);

  useClickOutside(containerRef, closeContainer);

  return (
    <div
      ref={containerRef}
      className={clsx([styles.petCheckbox, containerStyle])}
    >
      <div className={styles.petCheckbox__toggle} onClick={toggleContainer}>
        {value ? 'Pet Friendly' : 'Pets'}
      </div>

      {showContainer && (
        <div
          className={styles.petCheckbox__popup}
          onClick={(e) => e.stopPropagation()}
        >
          <Checkbox
            label="Pet Friendly"
            containerStyle={styles.petCheckbox__checkbox}
            onChange={onChange}
            value={value}
          />
        </div>
      )}
    </div>
  );
}
